import React from 'react'
import { JourneyNotificationsComparisonContext } from './journey-notifications-comparison-context'
import classnames from 'classnames'
import { SizeType } from 'antd/es/config-provider/SizeContext'
import { JourneyNotificationCompTabState } from './types'
import { Button, Divider, Tooltip } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'

type FilterKey = keyof JourneyNotificationCompTabState['filters']

interface IJNLHProps {
    title: string
    filterSize?: SizeType
    filtersAddonBefore?: React.ReactNode
    filtersAddonAfter?: React.ReactNode
    hideRefresh?: boolean
    hideRowSelection?: boolean
    hideFilters?: FilterKey | FilterKey[] | boolean
    filtersDisabled?: FilterKey | FilterKey[] | boolean
    hideCompare?: boolean
    compareLabel?: string
    refreshing?: boolean
}

export const JourneyNotificationsListHeader = (props: IJNLHProps) => {
    const context: React.ContextType<typeof JourneyNotificationsComparisonContext> = React.useContext(
        JourneyNotificationsComparisonContext,
    )

    const { filters, onRefreshClick, refreshEnabled, onCompareClick } = context

    const { title, filtersAddonBefore, filterSize, hideFilters, hideRefresh, hideCompare, compareLabel, refreshing } =
        props

    const compareDisabled = context.selectedNotifications.length < 2
    return (
        <div className={classnames('journey-notifs-list-header')}>
            <div className={classnames('journey-notifs-list-title')}>
                <span>{title}</span>
            </div>

            <div
                className={classnames('journey-notifs-list-compare', {
                    hidden: hideCompare,
                })}
            >
                <span className="compare-label">{compareLabel}</span>
                <Button className="ant-btn" disabled={compareDisabled} size={filterSize} onClick={onCompareClick}>
                    <span>Compare</span>
                </Button>
            </div>
            {!hideRefresh && (
                <>
                    <Divider type="vertical" orientation="center" />

                    <div
                        className={classnames('journey-notifs-list-refresh', {
                            hidden: hideRefresh,
                        })}
                    >
                        <Tooltip title="Refresh">
                            <Button
                                className={classnames('journey-notifs-list-refresh-toggle')}
                                disabled={!refreshEnabled}
                                size="small"
                                shape="round"
                                onClick={onRefreshClick}
                            >
                                <ReloadOutlined spin={refreshing} />
                            </Button>
                        </Tooltip>
                    </div>
                </>
            )}
        </div>
    )
}
